import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import UserForm from './UserForm';

const UserCreate = ({ basePath = '/app/users', scope = 'hke', context }) => {
  return (
    <Box mx="auto" p={6}>
      <Heading as="h2" size="lg" mb={6}>New User</Heading>
      <UserForm basePath={basePath} scope={scope} context={context} />
    </Box>
  );
};

export default UserCreate;
